// 261010 P8b-2 — thanh trên: ← Plans, tên plan, chuông CTA, menu ⋯ (Công cụ plan — P9D). Khung đủ không còn nút sang kiểu cũ (plan cũ / chưa chia vẫn có ở WorkflowPageStates). Chịu được `status = null`.
import React, { useContext } from 'react';
import { WorkflowTopExtraContext } from './WorkflowTopExtraContext';
import { Dropdown, Tooltip } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import type { WorkflowStatus } from '../../types/filmWorkflow';
import { truncateText } from './workflowBoardUtils';
import WorkflowBell from './WorkflowBell';
import WfIconButton from './WfIconButton';
import type { BellNav } from './workflowBellPolicy';

interface Props {
  planName: string;
  status: WorkflowStatus | null;
  bellOpen: boolean;
  onBellOpenChange: (open: boolean) => void;
  onOpenPlans: () => void;
  /** P9D D9 — mở drawer «Công cụ plan» (P8f). */
  onOpenTools: () => void;
  onReloadAll: () => void;
  dismissedJobIds: string[];
  onBellAction: (nav: BellNav) => void;
  bellError?: string | null;
}

const WorkflowTopBar: React.FC<Props> = ({
  planName, status, bellOpen, onBellOpenChange, onOpenPlans, onOpenTools, onReloadAll,
  dismissedJobIds, onBellAction, bellError,
}) => {
  const extra = useContext(WorkflowTopExtraContext);
  return (
  <div className={`wf-top${extra?.primary ? ' wf-top-board' : ''}`}>
    <div className="wf-top-l">
      <WfIconButton icon="back" label="Về danh sách Plans" className="ghost" onClick={onOpenPlans} testId="wf-back-plans" />
      <div className="wf-top-id">
        <span className={extra?.meta ? 'wf-top-name' : 'wf-crumb'} title={planName}>{truncateText(planName, 80)}</span>
        {extra?.meta ?? null}
      </div>
    </div>
    <div className="wf-top-r">
      <WorkflowBell
        status={status} open={bellOpen} onOpenChange={onBellOpenChange}
        dismissedJobIds={dismissedJobIds} onAction={onBellAction} releaseError={bellError}
      />
      <Dropdown trigger={['click']} menu={{ items: [
        { key: 'reload', label: 'Tải lại', onClick: () => onReloadAll() },
        { key: 'tools', label: 'Công cụ plan', onClick: () => onOpenTools() },
        { key: 'guide', label: 'Hướng dẫn (chưa có ở bản này)', disabled: true },
      ] }}>
        <span className="wf-ib-w"><Tooltip title="Thêm"><button type="button" className="wf-btn wf-ib" aria-label="Thêm"><EllipsisOutlined /></button></Tooltip></span>
      </Dropdown>
      {extra?.primary ?? null}
    </div>
  </div>
  );
};

export default WorkflowTopBar;
